
import Component, { mixins } from 'vue-class-component'
import Mixin from '../../mixin'
import { Prop } from 'vue-property-decorator'
import { db } from '../../main'

@Component
export default class UnlockClient extends mixins(Mixin) {
  @Prop() user
  dialog_unlock_user = false

  unlockUser() {
    this.showNotification('loading', 'Procesando', 'Un momento por favor')
    db.collection('users')
      .doc(this.user.uid)
      .update({
        'account_info.status': 1
      })
      .then(() => {
        //Deshabilitar los usuarios del cliente
        this.showNotification(
          'success',
          'Éxito',
          'Usuario desbloqueado con éxito'
        )
        this.dialog_unlock_user = false
      })
      .catch(error => {
        this.showNotification(
          'fail',
          'Error',
          'Ocurrió un error al desbloquear al usuario. Intenta nuevamente'
        )
        console.log(error)
        this.dialog_unlock_user = false
      })
  }
}
